import { onMounted, onUnmounted, ref } from "vue";

// CSS env(safe-area-inset-*) isn't directly readable from JS, so we measure
// it via a throwaway probe element sized with that env() value and read back
// its computed pixel height.
function measureInset(side: "top" | "bottom"): number {
  const probe = document.createElement("div");
  probe.style.position = "fixed";
  probe.style.visibility = "hidden";
  probe.style.pointerEvents = "none";
  probe.style.height = `env(safe-area-inset-${side})`;
  document.body.append(probe);
  const px = Number.parseFloat(getComputedStyle(probe).height) || 0;
  probe.remove();
  return px;
}

export function useSafeAreaInsets() {
  const top = ref(0);
  const bottom = ref(0);

  const update = () => {
    top.value = measureInset("top");
    bottom.value = measureInset("bottom");
  };

  onMounted(() => {
    update();
    globalThis.addEventListener("resize", update);
    globalThis.addEventListener("orientationchange", update);
  });

  onUnmounted(() => {
    globalThis.removeEventListener("resize", update);
    globalThis.removeEventListener("orientationchange", update);
  });

  return { top, bottom };
}
